//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { marked } from 'marked'
import {VueClazyLoad} from "vue-clazy-load";

export default {
  components: {VueClazyLoad},
  data() {
    return {
      promotion: null,
      opt_in_status: {
        'NotAllowed': 0,
        'Allowed': 1,
        'OptedIn': 2
      },
      promotion_types: {
        'Regular': 1,
        'Tournament': 2,
        'Events': 3,
        'Club': 4,
        'Deposit': 5
      }
    }
  },
  computed: {
    isOptedIn() {
      if (!this.user) return false
      return this.user.combo_boost_optin === 1;
    }
  },
  methods: {
    beforeOpen (data) {
      this.promotion = _.get(data, 'params.promotion')
      this.closedCb = _.get(data, 'params.closedCb')
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-combo-boost-promotion')
    },
    closed() {
      if (typeof this.closedCb === 'function') {
        this.closedCb()
      }
    },
    renderMd(string) {
      if (!string) return ''
      try {
        return marked.parse(string)
      } catch (e) {
        return e.message
      }
    },
    buttonClass() {
      if (this.isOptedIn) {
        return 'bg-gray-500 hover:bg-gray-600'
      }

      return 'bg-primary hover:bg-primary-600'
    },
    buttonText() {
      if (this.user) {
        if (this.isOptedIn) {
          return this.$t('Opted in')
        }
        return this.$t('Opt in')
      }
      return this.$t('Login')
    },
    showOptin() {
      return true
    },

    async optInButtonAction() {
      if (!this.user) {
        this.$modal.hide('modal-combo-boost-promotion')
        this.$modal.show('modal-login')
        return
      }
      if (!this.isOptedIn) {
        return await this.optIn();
      }
    },
    async optIn() {
      try {
        let response = await this.$new_cms().post('/api/cms/content/opt-in', {page_id: this.promotion.id})
        this.close()
        if (_.get(response, 'data.additional.result')) {
          this.$modal.show('modal-generic', {
            title: this.$t('Success!'),
            content: this.$t(_.get(response, 'data.message')),
          })
          const payload = {};
          payload['combo_boost_optin'] = 1;
          this.$store.commit('auth/storeUser', payload);
        } else {
          this.$modal.show('modal-generic', {
            title: this.$t('Sorry!'),
            content: this.$t(_.get(response, 'data.message')),
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
